import VadImage from "vadimages-nextjs-image-optimizer";

interface ResponsiveVadImageProps {
  src: string;
  width: number;
  height: number;
  alt: string;
  className?: string;
  mobileSrc: string;
  mobileWidth: number;
  mobileHeight: number;
  mobileAlt: string;
  mobileClassName?: string;
}

const ResponsiveVadImage = ({
  src,
  width,
  height,
  alt,
  className = "",
  mobileAlt,
  mobileClassName = "",
  mobileHeight,
  mobileSrc,
  mobileWidth,
}: ResponsiveVadImageProps) => {
  return (
    <>
      <div className="hidden md:block">
        <VadImage
          src={src}
          alt={alt}
          width={width}
          height={height}
          className={className}
        />
      </div>
      <div className="block md:hidden">
        <VadImage
          src={mobileSrc}
          alt={mobileAlt}
          width={mobileWidth}
          height={mobileHeight}
          className={mobileClassName}
        />
      </div>
    </>
  );
};

export default ResponsiveVadImage;
